import { useState } from 'react';
import { IconBuildingStore, IconChevronDown, IconCheck } from '@tabler/icons-react';
import { C, RADIUS } from '../theme';
import { useOrg } from './OrgContext';

// Workspace switcher — lists the user's active orgs; switching persists the choice
// and reloads so every page + the backend re-read under the new org. Renders a
// static label (no dropdown) for single-org users. Shared by AppHeader and Home.
export default function OrgSwitcher() {
  const { orgId, orgs, setOrgId } = useOrg();
  const [open, setOpen] = useState(false);
  if (!orgs || orgs.length === 0) return null;
  const current = orgs.find((o) => o.id === orgId) || orgs[0];
  const single = orgs.length <= 1;
  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => !single && setOpen((v) => !v)}
        aria-haspopup={!single}
        aria-expanded={open}
        title={current?.name || 'Workspace'}
        style={{
          display: 'flex', alignItems: 'center', gap: 6, padding: '6px 10px',
          borderRadius: RADIUS.md, background: C.card, border: `1px solid ${C.border}`,
          fontSize: 12.5, color: C.textDark, fontWeight: 500, fontFamily: 'inherit',
          cursor: single ? 'default' : 'pointer', maxWidth: 190,
        }}
      >
        <IconBuildingStore size={14} color={C.textMuted} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {current?.name || 'Workspace'}
        </span>
        {!single && <IconChevronDown size={14} color={C.textMuted} />}
      </button>
      {open && !single && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 40 }} />
          <div
            role="menu"
            style={{
              position: 'absolute', top: '100%', left: 0, marginTop: 6, minWidth: 210,
              background: C.card, border: `1px solid ${C.border}`, borderRadius: RADIUS.md,
              boxShadow: '0 4px 16px rgba(0,0,0,0.10)', zIndex: 41, overflow: 'hidden',
            }}
          >
            {orgs.map((o, i) => (
              <button
                key={o.id}
                type="button"
                onClick={() => { setOpen(false); if (o.id !== orgId) setOrgId(o.id); }}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
                  width: '100%', textAlign: 'left', padding: '9px 12px',
                  background: o.id === orgId ? C.bg : C.card, border: 'none',
                  borderTop: i ? `1px solid ${C.border}` : 'none',
                  fontSize: 13, color: C.textDark, cursor: 'pointer', fontFamily: 'inherit',
                }}
              >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {o.name || o.slug || o.id}
                </span>
                {o.id === orgId && <IconCheck size={14} color={C.orange} />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
